var map = {
	"./4.jpg": "CtaL",
	"./404-bg.png": "NmAL",
	"./5.jpg": "8FcD",
	"./about.png": "bbtd",
	"./arrow_left.svg": "5p9W",
	"./arrow_right.svg": "8fWD",
	"./arrow_top.svg": "cR76",
	"./best_pizza.png": "aujJ",
	"./best_pizza_2.png": "DjUB",
	"./blog_1.jpg": "k9U0",
	"./blog_2.jpg": "DR0a",
	"./blog_3.jpg": "iNG9",
	"./blog_s1.jpg": "rYlM",
	"./blog_s2.jpg": "yrn7",
	"./blog_s3.jpg": "glgJ",
	"./bugar_2.png": "wX7p",
	"./burgur-1.png": "efD3",
	"./chef-bg.png": "lCK8",
	"./choose_pizza.png": "AGJ4",
	"./concrete-wall.png": "/P6+",
	"./delivery_bike.png": "cF8G",
	"./double_fun_bg.png": "RR4V",
	"./double_fun_pizza.png": "fsj3",
	"./double_fun_shape.png": "maDd",
	"./double_fun_shape_2.png": "skMB",
	"./fa-solid-900.svg": "SztR",
	"./favicon/favicon-32x32.png": "mlXf",
	"./food_menu_bg.jpg": "ATo3",
	"./food_menu_bg.png": "+u3R",
	"./food_menu_pizza.png": "FQwL",
	"./food_menu_shape_1.png": "kRa1",
	"./food_menu_shape_2.png": "DCCN",
	"./food_menu_shape_3.png": "6qpe",
	"./footer_logo.png": "t0Qz",
	"./gallery_1.jpg": "5U5S",
	"./gallery_10.jpg": "Xmbr",
	"./gallery_11.jpg": "ts9Q",
	"./gallery_12.jpg": "7mkG",
	"./gallery_2.jpg": "2aVw",
	"./gallery_3.jpg": "4O9j",
	"./gallery_4.jpg": "DjeT",
	"./gallery_5.jpg": "b+La",
	"./gallery_6.jpg": "8apN",
	"./gallery_7.jpg": "buLb",
	"./gallery_8.jpg": "kdMA",
	"./gallery_9.jpg": "FT3o",
	"./hero_pizza.png": "HQqe",
	"./hero_shape_1.png": "hX9M",
	"./hero_shape_2.png": "50Nw",
	"./hero_shape_3.png": "o7E2",
	"./hero_shape_4.png": "sMKo",
	"./hero_shape_5.png": "9n64",
	"./ice-cream-1.png": "uDnu",
	"./ice-cream-2.png": "ze3C",
	"./icon01.png": "zhR6",
	"./icon02.png": "RJrZ",
	"./icon03.png": "IXv1",
	"./icon04.png": "NdzI",
	"./juice_1.png": "gu5M",
	"./juice_2.png": "1nvm",
	"./juice_3.png": "9WqJ",
	"./list_circle.png": "7Pfs",
	"./login.png": "Nl6a",
	"./logo.png": "dLd/",
	"./logo_black.png": "q3zs",
	"./master-card.jpg": "h3DV",
	"./menu_pattern3-min.png": "qx4o",
	"./offer1.png": "oskd",
	"./offer2.png": "enLx",
	"./p-6.png": "B28G",
	"./pasta.png": "9Am7",
	"./paypal.jpg": "TUSe",
	"./pizza-7942.png": "gYyq",
	"./pizza_slide_1.png": "RdXw",
	"./pizza_slide_2.png": "8nkr",
	"./pizza_slide_3.png": "toNc",
	"./pizza_slide_4.png": "mr16",
	"./promo_add.jpg": "gLn9",
	"./promo_leaf_bg.png": "T3sw",
	"./promo_order_1.jpg": "fUEF",
	"./promo_order_2.jpg": "OEFX",
	"./promo_order_3 - Copy.jpg": "hBcI",
	"./promo_order_3.jpg": "35xm",
	"./promo_order_4.png": "j1zz",
	"./salad_1.png": "ARjB",
	"./scroll_pizza_1.png": "S3wv",
	"./scroll_pizza_2.png": "S4yd",
	"./section_delimiter.png": "uGPa",
	"./section_shape.png": "vW4+",
	"./shape23.png": "P8Il",
	"./shape_10.png": "rDjS",
	"./shape_11.png": "nys/",
	"./shape_12.png": "UKqA",
	"./shape_13.png": "nmcA",
	"./shape_14.png": "bE0O",
	"./shape_15.png": "3MO3",
	"./shape_16.png": "wBnZ",
	"./shape_17.png": "rU5R",
	"./shape_6.0908ddc.png": "Y1wk",
	"./shape_6.png": "kblJ",
	"./shopping-bag-black.svg": "arJ8",
	"./shopping-bag.svg": "aaqm",
	"./social_bg.png": "NvM0",
	"./social_bg_hover.png": "cayV",
	"./t1.png": "vo0/",
	"./t3.png": "R3rN",
	"./telephone.svg": "pkxi",
	"./testimonial-bg.png": "bkZE"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "czpq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*$
// module id = czpq
// module chunks = 0